import stdtrtestLabels from 'assets/labels/stdtrtest'

export const mocker = {
  labels () {
    return {
      labels: stdtrtestLabels
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/stdtrtest/mocker.js